import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';

export default function LoadListFilterProductList(props) {
    //console.debug("RTS Break LoadListFilterProductList");

    const [isLoading, setIsLoading] = useState(true);

    const [products, setProducts] = useState();
    const [repoProducts, setRepoProducts] = useState();


    useEffect(() => {
        if(props.products===null){
            setProducts([]);
        }
        else{
            setProducts(props.products);
        }

        if(props.data == null){
            setRepoProducts([]);
        }
        else{
            setRepoProducts(props.data);
        }

        setIsLoading(false);
    }, [props]);     



    function valChange(e, val){
        props.setProductsFx(val);
        setProducts(val);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
            <Autocomplete
                options={repoProducts}
                renderInput={(params) => <TextField {...params} label="Products" size="small" />}
                value={products}
                onChange={valChange}
                getOptionLabel={(product) => product.name + " (" + product.idSap + ")" }
                renderOption={(props, repoProducts) => (
                    <Box component="li" {...props} key={repoProducts.idSap}>
                        {repoProducts.name + " (" + repoProducts.idSap + ")"}
                    </Box>
                )}
                multiple
            />
        </>
    );
}
